module.exports = __webpack_public_path__ + "img/triduum-m-w.2a9157c5.svg";